import { Star } from "lucide-react";
import { useSeo } from "@/lib/seo";
import { FILIERES, PRIORITY, IMG } from "@/lib/content";
import { PageHero, SectionTitle, Reveal } from "@/components/kit";
import { DynamicForm } from "@/components/forms/DynamicForm";
import { TRAINING_FIELDS } from "@/components/forms/configs";

export default function Training() {
  useSeo("Centre de formation professionnelle", "Centre de Formation Professionnelle et d'Apprentissage aux Métiers MA LEBA : 14 filières, inscription en ligne.");
  return (
    <div data-testid="training-page">
      <PageHero eyebrow="Association MA LEBA" title="Centre de formation professionnelle" image={IMG.training}
        intro="Formations en informatique et intelligence artificielle et dans plusieurs domaines pour l'avenir de demain." />
      <section className="pagne py-16">
        <div className="container-x">
          <SectionTitle eyebrow="Catalogue" title="Nos filières" className="mb-10" />
          <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4" data-testid="filieres-grid">
            {FILIERES.map(({ icon: Icon, title }, i) => (
              <Reveal key={title} delay={Math.min(i * 0.03, 0.3)}>
                <a href="#inscription" className="card group flex h-full items-start gap-4 p-5 transition-colors hover:border-u" data-testid={`filiere-card-${i}`}>
                  <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-lg bg-u-soft text-u transition-colors group-hover:bg-u group-hover:text-white">
                    <Icon className="h-5 w-5" aria-hidden="true" />
                  </span>
                  <span className="font-display text-lg font-semibold uppercase leading-tight text-ink">{title}</span>
                </a>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
      <section className="bg-ink py-14 text-white" data-testid="training-priority">
        <div className="container-x grid gap-8 lg:grid-cols-2 lg:items-center">
          <SectionTitle light eyebrow="Accès prioritaire" title="Priorité à celles et ceux qui en ont le plus besoin" />
          <ul className="grid gap-3 sm:grid-cols-2">
            {PRIORITY.map((p) => (
              <li key={p} className="flex items-center gap-3 rounded-lg border border-white/15 bg-white/5 p-4 font-semibold">
                <Star className="h-5 w-5 shrink-0 text-gold" aria-hidden="true" /> {p}
              </li>
            ))}
          </ul>
        </div>
      </section>
      <section id="inscription" className="scroll-mt-28 py-16">
        <div className="container-x max-w-4xl">
          <SectionTitle eyebrow="Inscription" title="S'inscrire à une formation" className="mb-8" />
          <div className="card p-6 sm:p-10">
            <DynamicForm fields={TRAINING_FIELDS} endpoint="/applications/formation" testid="training-form" submitLabel="M'inscrire"
              successText="Votre inscription a bien été enregistrée. Notre équipe vous contactera par téléphone." />
          </div>
        </div>
      </section>
    </div>
  );
}
